import { useEffect, useState } from 'react';
import { useAuth } from '../lib/AuthContext.js';
import { ApiClient } from '../lib/api.js';

export function History() {
  const { getToken } = useAuth();
  const api = new ApiClient(getToken);
  const [drafts, setDrafts] = useState<any[]>([]);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api.listDrafts().then(r => setDrafts(r.drafts ?? [])).catch(e => setErr(e.message));
    /* eslint-disable-next-line */
  }, []);

  return (
    <div className="page">
      <div className="page-head">
        <h1>Draft history</h1>
        <p className="lede">Everything tweetvia has drafted for you, with what you did with each one.</p>
      </div>
      {err && <div className="error">{err}</div>}
      {drafts.length === 0 ? (
        <div className="card empty"><p className="muted">No drafts yet. Generate one from /app/write or via the Chrome extension.</p></div>
      ) : (
        <div className="stack">
          {drafts.map(d => (
            <div key={d.draftId} className="card">
              <div className="button-row between">
                <div>
                  <strong>{d.title ?? d.topic ?? d.mode}</strong>
                  {d.host && <div className="muted small">{d.host} · {d.surface} · {d.mode}</div>}
                </div>
                <div className="muted small">{d.action ?? 'none'}</div>
              </div>
              {d.variants?.[0]?.text && (
                <p style={{ marginTop: 10, color: 'var(--text-dim)', lineHeight: 1.5, fontSize: 14 }}>{d.variants[0].text}</p>
              )}
              {d.url && (
                <div className="button-row end" style={{ marginTop: 8 }}>
                  <a className="muted small" href={d.url} target="_blank" rel="noreferrer">{d.url}</a>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
